<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="medium"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.table_label_productLine') || '产品线'"
            prop="productLine"
          >
            <dict-select
              size="medium"
              clearable
              disabled
              filterable
              v-model="formData.productLine"
              :body="productLineParams"
              url="/sys/common/dict/system"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_main_material_category') || '1级物料分类'"
            prop="mainMaterialCategoryCode"
            ref="mainMaterialForm"
          >
            <dict-select
              :disabled="
                formData.productLine == null || formData.productLine == ''
              "
              size="medium"
              clearable
              filterable
              v-model="formData.mainMaterialCategoryCode"
              :body="mainMaterialParams"
              @change="updateMaterial"
              url="/master/material/category/select"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_detail_material_category') || '2级物料分类'"
            prop="detailMaterialCategoryCode"
            ref="detailMaterialForm"
          >
            <dict-select
              size="medium"
              clearable
              filterable
              v-model="formData.detailMaterialCategoryCode"
              :body="detailMaterialParams"
              :disabled="
                formData.mainMaterialCategoryCode == null ||
                  formData.mainMaterialCategoryCode == ''
              "
              @change="updateMaterial"
              url="/master/material/category/select"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_materialNo') || '物料编号'"
            ref="material"
            prop="materialNo"
          >
            <el-input clearable v-model="formData.materialNo" readonly>
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="addMaterial"
                size="medium"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item :label="$l('form_label_materialColor') || '颜色'">
            <el-input
              v-model="formData.materialColor"
              clearable
              show-word-limit
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 8 }">
          <el-form-item :label="$l('form_label_materialSpec') || '规格'">
            <el-input
              v-model="formData.materialSpec"
              clearable
              show-word-limit
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 6 }">
          <el-form-item :label="$l('form_label_fabricLoss') || '损耗'">
            <el-input-number
              controls-position="right"
              style="width: 100%"
              :min="0"
              :precision="2"
              :step="0.01"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.fabricLoss"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 6 }">
          <el-form-item
            :label="$l('form_label_net_unit_consumption') || '净单耗'"
          >
            <el-input-number
              controls-position="right"
              style="width: 100%"
              :min="0"
              :precision="3"
              :step="0.001"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.unitQty"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 6 }">
          <el-form-item :label="$l('form_label_fabricQty') || '耗料'">
            <el-input-number
              controls-position="right"
              style="width: 100%"
              :min="0"
              :precision="3"
              :step="0.001"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.fabricQty"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 6 }">
          <el-form-item
            :label="$l('form_label_total_material_consumption') || '合计耗料'"
          >
            <el-input-number
              controls-position="right"
              style="width: 100%"
              :min="0"
              :precision="3"
              :step="0.001"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              v-model="formData.subQty"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>

    <choose-material-dialog
      :title="$l('INDEX.material_choose_title') || '添加物料信息'"
      :visible.sync="chooseMaterialDialogVisible"
      :productLine="formData.productLine"
      :detailMaterialCategoryCode="formData.detailMaterialCategoryCode"
      :mainMaterialCategoryCode="formData.mainMaterialCategoryCode"
      type="radio"
      @confirm="onMaterialConfirm"
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    techGoodsMaterialCode: { type: String, default: '' },
    productLine: { type: String, default: '' },
    techGoodsSpecCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      chooseMaterialDialogVisible: false,
      formData: {
        productLine: '',
        mainMaterialCategoryCode: '',
        detailMaterialCategoryCode: '',
        materialCode: '',
        materialNo: '',
      },
      productLineParams: { dictType: 'productLine' },
      mainMaterialParams: {},
      detailMaterialParams: {},
      rules: {
        productLine: [
          {
            required: true,
            message: this.$l('form_placeholder_product_line') || '请选择产品线',
            trigger: 'change',
          },
        ],
        mainMaterialCategoryCode: [
          {
            required: true,
            message:
              this.$l('pe_select_Level_1_material_classification') ||
              '请选择1级物料分类',
            trigger: 'change',
          },
        ],
        detailMaterialCategoryCode: [
          {
            required: true,
            message:
              this.$l('pe_select_Level_2_material_classification') ||
              '请选择2级物料分类',
            trigger: 'change',
          },
        ],
        materialNo: [
          {
            required: true,
            message: this.$l('pe_select_material') || '请选择物料',
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    'formData.productLine'() {
      this.$refs.mainMaterialForm.resetField()
      this.$refs.detailMaterialForm.resetField()
      this.detailMaterialParams = { parentCode: '' }
      this.mainMaterialParams = { parentCode: this.formData.productLine }
    },
    'formData.mainMaterialCategoryCode'() {
      this.$refs.detailMaterialForm.resetField()
      this.detailMaterialParams = {
        parentCode: this.formData.mainMaterialCategoryCode,
      }
    },
  },
  mounted() {
    this.formData.productLine = this.productLine
    this.getData()
  },
  methods: {
    getData() {
      if (!this.techGoodsMaterialCode) return
      this.$api
        .techGoodsMaterialDetailApi({
          techGoodsMaterialCode: this.techGoodsMaterialCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])

      if (!result) return (this.backDialogVisible = false)

      const parms = {
        ...this.formData,
        techGoodsSpecCode: this.techGoodsSpecCode,
      }

      this.loadingOpen()
      //根据不同的操作调用不同接口
      let saveApi = {}
      if (!this.techGoodsMaterialCode) {
        saveApi = this.$api.techGoodsMaterialAddSaveApi(parms)
      } else {
        saveApi = this.$api.techGoodsMaterialEditSaveApi(parms)
      }
      saveApi

        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.$emit('close')
            this.$emit('reload')
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    addMaterial() {
      const { detailMaterialCategoryCode } = this.formData
      if (!detailMaterialCategoryCode) {
        this.$message.warning(
          this.$l('pe_select_Level_2_material_classification') ||
            '请选择2级物料分类'
        )
        return
      }
      this.chooseMaterialDialogVisible = true
    },
    onMaterialConfirm(data) {
      if (!data) return
      this.formData.materialCode = data.materialCode
      this.formData.materialNo = data.materialNo
      this.formData.materialName = data.materialName
      this.formData.materialNameEn = data.materialNameEn
    },
    updateMaterial() {
      this.formData.materialCode = ''
      this.formData.materialNo = ''
      this.formData.materialName = ''
      this.formData.materialNameEn = ''
    },
  },
}
</script>
